module.exports = __webpack_public_path__ + "fonts/bc76e89dce3bb743f5c61a049a7b85ee.svg";